import lazySizes from 'lazysizes';
import rlxSlider from './components/rlxSlider';
import rlxSliderWatchCover from './components/rlxSliderWatchCover';
import rlxScrollTo from './components/rlxScrollTo';
import rlxNavigation from './components/rlxNavigation';
import rlxStoreMap from './components/rlxStoreMap';
import rlxContactValidation from './components/rlxContactValidation';
import rlxContactLocationChooser from './components/rlxContactLocationChooser';
import rlxTracking from './components/rlxTracking';
import rlxOpeningTimes from './components/rlxOpeningTimes';
import jqueryEmotion from './jquery.emotion';
import rlxLocatorMap from './components/rlxLocatorMap';
import rlxWatchGrid from './components/rlxWatchGrid';
import rlxOpenCituro from './components/rlxOpenCituro';
import rlxCollapseWatchPage from './components/rlxCollapseWatchPage';
import rlxModelLightbox from './components/rlxModelLightbox';
import rolexCPOSliderWatchCover from '../rolex-cpo/components/rolexCPOSliderWatchCover';
import initProduct360View from './components/threeSixtyViewer';
import rlxMultiStoreDetailOverlay from './components/rlxMultiStoreDetailOverlay';

rlxSlider();
rlxSliderWatchCover();

$(document).ready(() => {
    jqueryEmotion();
    rlxScrollTo();
    rlxNavigation();
    rlxStoreMap();
    rlxContactValidation();
    rlxContactLocationChooser();
    rlxTracking();
    rlxOpeningTimes();
    rlxLocatorMap();
    rlxWatchGrid();
    rlxOpenCituro();
    rlxCollapseWatchPage();
    rlxModelLightbox();
    // img-lazy-loading settings
    lazySizes.cfg = lazySizes.cfg || {};
    lazySizes.cfg.expand = 370;
    rolexCPOSliderWatchCover();
    initProduct360View();
    rlxMultiStoreDetailOverlay();
});

